export type UiTheme =
  | 'dark'
  | 'light'
  | 'blue'
  | 'gray'
  | 'darkGray'
  | 'orange'
  | 'red'
  | 'green'
  | 'yellow'
  | 'purple'
  | 'teal'

export const dark = {
  backgroundColor: '#404e59',
  color: 'white',
}

export const light = {
  backgroundColor: 'white',
  color: '#298bff',
  border: '1px solid #e2e2e2',
}

export const blue = {
  backgroundColor: '#298bff',
  color: 'white',
}

export const gray = {
  backgroundColor: '#ccd',
  color: 'white',
}

export const darkGray = {
  backgroundColor: '#7A91A8',
  color: 'white',
}

export const orange = {
  backgroundColor: '#eea900',
  color: 'white',
}

export const red = {
  backgroundColor: '#ff6666',
  color: 'white',
}

export const green = {
  backgroundColor: '#02BB4F',
  color: 'white',
}

export const yellow = {
  backgroundColor: '#FFC400',
  color: 'white',
}

export const purple = {
  backgroundColor: '#9575CD',
  color: 'white',
}

export const teal = {
  backgroundColor: '#00BFA5',
  color: 'white',
}
